import {
  responsiveMediaFragment
} from './mediaFragments.gql'
import {
  localeFragment,
  internalLinkFragment,
} from "./fragments.gql"
import type { ResponsiveImageType } from 'vue-datocms'

export interface NavigationLink {
  id: string
  _modelApiKey: "navigation_link"
  linkText: string
  internalLink: {
    id: string
    slug: string
    __typename: any
  },
  internalLinkQueryParams: string | null
  __typename: "NavigationLinkRecord"
  showOnMenuBar: 'show' | 'hide'
}

export interface NavigationImageCard {
  _modelApiKey: 'navigation_image_card'
  id: string
  image: {
    responsiveImage: ResponsiveImageType
    focalPoint: {
      x: number
      y: number
    }
  }
  linkText: string
  internalLink: {
    id: string
    slug: string
    __typename: any
  },
  internalLinkQueryParams: string | null
  cardTextPosition: 'bottom-card' | 'below-card'
}

export interface NavigationImageCardRow {
  id: string
  _modelApiKey: "navigation_image_card_row"
  items: NavigationImageCard[]
}

interface NavigationButton {
  id: string,
  _modelApiKey: "navigation_button",
  buttonText: string,
  nestedItemsLayout: "single-line" | 'image-grid',
  nestedItems: NavigationLink[] | NavigationImageCardRow[],
  secondaryNestedItems: NavigationLink[]
  __typename: "NavigationButtonRecord"
  showOnMenuBar: 'show' | 'hide'
}

export type MainNavigationItems = (NavigationButton | NavigationLink)[]
export type SecondaryNavigationItems = (NavigationButton | NavigationLink)[]

export interface Navigation {
  navigation: {
    mainNavigationItems: MainNavigationItems
    secondaryNavigationItems: SecondaryNavigationItems
  }
}

export default `query NavigationQuery($locale: SiteLocale) {
  navigation(${localeFragment}) {
    mainNavigationItems {
      ... on NavigationLinkRecord {
        id
        _modelApiKey
        linkText
        showOnMenuBar
        internalLink {
          ${internalLinkFragment}
        }
        internalLinkQueryParams
      }
      ... on NavigationButtonRecord {
        id
        _modelApiKey
        buttonText
        showOnMenuBar
        nestedItemsLayout
        nestedItems {
          ... on NavigationLinkRecord {
            id
            _modelApiKey
            linkText
            internalLink {
              ${internalLinkFragment}
            }
            internalLinkQueryParams
          }
          ... on NavigationImageCardRowRecord {
            id
            _modelApiKey
            items {
              id
              _modelApiKey
              ${responsiveMediaFragment('image', '{ w: 200 }')}
              linkText
              internalLink {
                ${internalLinkFragment}
              }
              internalLinkQueryParams
              cardTextPosition
            }
          }
        }
        secondaryNestedItems {
          ... on NavigationLinkRecord {
            id
            _modelApiKey
            linkText
            internalLink {
              ${internalLinkFragment}
            }
            internalLinkQueryParams
          }
        }
      }
    }
    secondaryNavigationItems {
      ... on NavigationLinkRecord {
        id
        _modelApiKey
        linkText
        internalLink {
          ${internalLinkFragment}
        }
        internalLinkQueryParams
        showOnMenuBar
      }
      ... on NavigationButtonRecord {
        id
        _modelApiKey
        buttonText
        nestedItemsLayout
        showOnMenuBar
        nestedItems {
          ... on NavigationLinkRecord {
            id
            _modelApiKey
            linkText
            internalLink {
              ${internalLinkFragment}
            }
            internalLinkQueryParams
          }
          ... on NavigationImageCardRowRecord {
            id
            _modelApiKey
            items {
              id
              _modelApiKey
              ${responsiveMediaFragment('image', '{ w: 200 }')}
              linkText
              internalLink {
                ${internalLinkFragment}
              }
              internalLinkQueryParams
              cardTextPosition
            }
          }
        }
        secondaryNestedItems {
          ... on NavigationLinkRecord {
            id
            _modelApiKey
            linkText
            internalLink {
              ${internalLinkFragment}
            }
            internalLinkQueryParams
          }
        }
      }
    }
  }
}`
